import * as React from 'react';

const Plus = ({
  fill = '#4A4F4A',
  width = '16',
  height = '16'
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width + 'px'}
    height={height + 'px'}
    viewBox="0 0 16 16">
    <g
      id="Screens"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g
        id="A---02-Product-Discovery---03.02.02-Logged-in"
        transform="translate(-1027 -706)"
        fill={fill}>
        <g id="Button" transform="translate(883 690)">
          <path
            d="M152 16a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6h-6a1 1 0 1 1 0-2l6-.001V17a1 1 0 0 1 1-1z"
            id="create"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Plus;
